import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

export const keyPermitDoc = (permitId) => ['keyPermitDoc', permitId];

const getPermitDocuments = async (permitId) => {
  return await request.get(
    `/Access/transport/${permitId}/attachments`,
    null,
    'При получении документов произошла ошибка'
  );
};

const usePermitDocuments = (permitId, options) =>
  useQuery(keyPermitDoc(permitId), () => getPermitDocuments(permitId), options);

export default usePermitDocuments;
